import { ListItemIcon as MUIListItemIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const ListItemIcon = withStyles({
  root: { minWidth: '2rem' }
})(MUIListItemIcon);

export default ListItemIcon;
